module.exports = __webpack_public_path__ + "static/media/11.589d44c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/11.jpg
// module id = 380
// module chunks = 0